import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=4f56f54b&scoped=true&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&id=4f56f54b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f56f54b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {XcoinsMoreProducts: require('/var/jenkins_home/workspace/prod-web-xfans/components/xcoins/MoreProducts.vue').default})
